module.exports = __webpack_public_path__ + "static/media/toolbar_go_b_white_i.2eae22cc.png";